import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "../../lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/85",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/85",
        outline: "text-foreground border-border",
        soft:
          "border-transparent bg-primary-light text-primary",
        success:
          "border-success/20 bg-success/10 text-green-700 dark:text-green-400",
        warning:
          "border-warning/25 bg-warning/12 text-amber-700 dark:text-amber-400",
        info:
          "border-info/20 bg-info/10 text-sky-700 dark:text-sky-400",
        danger:
          "border-danger/20 bg-danger/10 text-red-700 dark:text-red-400",
        halfday:
          "border-purple/20 bg-purple/10 text-violet-700 dark:text-violet-400",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
